import { render, staticRenderFns } from "./DialogEditGroupInStudent.vue?vue&type=template&id=6aedbd59&scoped=true"
import script from "./DialogEditGroupInStudent.vue?vue&type=script&lang=js"
export * from "./DialogEditGroupInStudent.vue?vue&type=script&lang=js"
import style0 from "./DialogEditGroupInStudent.vue?vue&type=style&index=0&id=6aedbd59&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aedbd59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aedbd59')) {
      api.createRecord('6aedbd59', component.options)
    } else {
      api.reload('6aedbd59', component.options)
    }
    module.hot.accept("./DialogEditGroupInStudent.vue?vue&type=template&id=6aedbd59&scoped=true", function () {
      api.rerender('6aedbd59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogEditGroupInStudent.vue"
export default component.exports